export default "__VITE_ASSET__Bl9rJt2$__"